import axios from 'axios';

export const actions = {
    async getNacionalidadesApi(){
        let url = 'https://api-conta.redegoverno.am.gov.br/api/v1/nacionalidades';
        try{
            return await axios.get(url);
        }catch (e) {
            console.log(e)
        }
    },
    async listMunicipios () {
        let url = 'https://api-conta.redegoverno.am.gov.br/api/v1/municipio/uf/am';
        try{
            return await axios.get(url);
        }catch (e) {
            console.log(e)
        }
    },
    async getAddressByCepModule(state,cep){
        let url = 'https://api-localize.auxilioemergencial.am.gov.br/api/v1/cep/';
        url = url + cep;
        try {
             return await axios.get(url);
        }catch (e) {
            console.log(e);
        }
    },
    setCidadao(state, cidadao) {
        state.commit('setCidadao', cidadao);
    },
    async loadCidadao(state) {
        console.log('loadCidadao')
          try {
              let response = await axios.get('/cidadao');
              state.commit('setCidadao', response.data);
          } catch (e) {
              console.log(e);
          }
    },

    async saveDadosPessoais(state, payload) {
        console.log('saveDadosPessoais')
        try {
            await axios.put(`/cidadao/dados-pessoais`, payload);
            state.dispatch('loadCidadao');
        } catch (e) {
            console.log(e);
        }
    },

    async saveDadosResidenciais(state, payload) {
        console.log('saveDadosResidenciais',payload)
        try {
            await axios.put(`/cidadao/dados-residenciais`, payload);

            state.dispatch('loadCidadao');
        } catch (e) {
            console.log(e);
        }
    },

    async saveDadosAcesso(state, payload) {
        console.log('saveDadosAcesso',payload)
        try {
            await axios.put(`/cidadao/dados-acesso`, payload);

            state.dispatch('loadCidadao');
        } catch (e) {
            console.log(e);
        }
    }

};
